import { makeStyles } from "@material-ui/core";
import React from "react";
import { Switch, Route } from "react-router-dom";
import SelectClient from "../../Components/SelectClient";
import DashboarProjet from "./DashboardProjet";
import { useHistory } from "react-router-dom";
import { useProjet } from "../../Contexts/projet";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    height: "60vh",
  },
}));

function Client() {
  const classes = useStyles();
  let history = useHistory();
  const { setFolder } = useProjet();

  const onSelect = folder => {
    setFolder(folder);
    history.push(`/client/${folder.title}`)
  }

  return (
    <div>
      <Switch>
        <Route path="/client/:client">
          <DashboarProjet isClient={true}/>
        </Route>
        <Route path="/client">
          <div className={classes.root}>
            <SelectClient onSelect={onSelect}/>
          </div>
        </Route>
      </Switch>
    </div>
  );
}

export default Client;
